var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import "../stylesheets/components/GenericCollapsibleNavigation.scss";
import { Link, useLocation } from "react-router-dom";
import Edelicon from "./Generic/Edelicon";
export var ESidebarTrigger;
(function (ESidebarTrigger) {
    ESidebarTrigger["HOVER"] = "HOVER";
    ESidebarTrigger["CLICK"] = "CLICK";
})(ESidebarTrigger || (ESidebarTrigger = {}));
var GenericCollapsibleNavigation = function (props) {
    var _a = props.isShowCollapseIcon, isShowCollapseIcon = _a === void 0 ? true : _a;
    var location = useLocation();
    var _b = __read(React.useState({ eventKey: "", isShow: false }), 2), isShowSubList = _b[0], setIsShowSubList = _b[1];
    var _c = __read(React.useState(false), 2), isShowOpenedSidebarPermanently = _c[0], setIsShowOpenedSidebarPermanently = _c[1];
    var _d = __read(React.useState(props.trigger ? props.trigger : ESidebarTrigger.CLICK), 2), sidebarTrigger = _d[0], setSidebarTrigger = _d[1];
    var generateIcon = function (name) {
        return typeof name === "string" ? (React.createElement("span", { className: "collapsed-sidebar-link" }, name.charAt(0).toUpperCase())) : (React.createElement(React.Fragment, null));
    };
    var generateCollapsedComponents = function () {
        return (React.createElement("div", { className: "primary-container ".concat((props === null || props === void 0 ? void 0 : props.parentClass) ? props === null || props === void 0 ? void 0 : props.parentClass : "", " collapsed-sidebar"), id: "collapsed-sidebar" },
            React.createElement("div", { className: "header-wrapper d-flex align-items-center justify-content-between" },
                props.collapsedHeader ? props.collapsedHeader : React.createElement(React.Fragment, null),
                props.collapseIcon ? (props.collapseIcon) : isShowCollapseIcon ? (React.createElement("span", { className: "collapse-icon-arrow-right hand_cursor", onClick: sidebarTrigger === ESidebarTrigger.HOVER
                        ? function () {
                            props.setIsCollapsed(false);
                        }
                        : function () {
                            props.setIsCollapsed(false);
                        } },
                    React.createElement("i", { className: "edel-icon-arrow-right1" }))) : (React.createElement(React.Fragment, null))),
            React.createElement("div", { className: "body-footer-container", onMouseEnter: sidebarTrigger === ESidebarTrigger.HOVER
                    ? function () {
                        props.setIsCollapsed(false);
                    }
                    : function () { }, onMouseLeave: sidebarTrigger === ESidebarTrigger.HOVER
                    ? function () {
                        props.setIsCollapsed(true);
                    }
                    : function () { } },
                React.createElement("div", { className: "body-wrapper" }, props.navigationMenu.map(function (item, index) {
                    var _a, _b;
                    return item.subList && item.subList.length ? (React.createElement(Link, { className: "collapsed-sidebar-link-container hand_cursor DMSanM_14_500 ".concat(item.className ? item.className : "", " ").concat(item.subList
                            .map(function (val) {
                            return val.route;
                        })
                            .indexOf(location.pathname) > -1
                            ? "active-tab"
                            : ""), to: item.route, state: (_a = item === null || item === void 0 ? void 0 : item.routeState) !== null && _a !== void 0 ? _a : null, key: index, title: typeof item.title === "string" && item.title }, item.icon ? (React.createElement("span", { className: "icon-container" }, item.icon)) : (generateIcon(item.title)))) : (React.createElement(React.Fragment, null,
                        React.createElement(Link, { className: "collapsed-sidebar-link-container hand_cursor DMSanM_14_500 ".concat(item.className ? item.className : "", " ").concat(location.pathname === item.route ? "active-tab" : ""), to: item.route, state: (_b = item === null || item === void 0 ? void 0 : item.routeState) !== null && _b !== void 0 ? _b : null, key: index, title: typeof item.title === "string" && item.title }, item.icon ? (React.createElement("span", { className: "icon-container" }, item.icon)) : (generateIcon(item.title)))));
                })),
                React.createElement("div", { className: "footer-wrapper" }, props.collapsedFooter ? props.collapsedFooter : React.createElement(React.Fragment, null)))));
    };
    var animateOnClose = function () {
        if (props.sideBarRef && props.sideBarRef.current.style) {
            props.sideBarRef.current.style.animation = "closingSidebar 110ms linear";
        }
        // openedSidebarRef.current.style.transition = "all 250ms";
        var timeoutId = setTimeout(function () {
            // props.setIsCollapsed(!props.isCollapsed);
            props.setIsCollapsed(true);
            clearTimeout(timeoutId);
        }, 50);
    };
    var generateOpenedComponents = function () {
        return (React.createElement("div", { ref: props.sideBarRef, className: "primary-container ".concat((props === null || props === void 0 ? void 0 : props.parentClass) ? props === null || props === void 0 ? void 0 : props.parentClass : "", " opened-sidebar "), 
            // className={`primary-container ${
            //   props?.parentClass ? props?.parentClass : ""
            // } opened-sidebar ${isShowOpenedSidebarPermanently && "open-always"}`}
            onMouseEnter: sidebarTrigger === ESidebarTrigger.HOVER
                ? function (e) {
                    props.setIsCollapsed(false);
                }
                : function () { } },
            React.createElement("div", { className: "header-wrapper d-flex align-items-center justify-content-between" },
                props.header ? props.header : React.createElement(React.Fragment, null),
                props.collapseIcon ? (props.collapseIcon) : isShowCollapseIcon ? (React.createElement("span", { className: "collapse-icon-arrow-right hand_cursor", onClick: sidebarTrigger === ESidebarTrigger.HOVER
                        ? function () {
                            animateOnClose();
                        }
                        : function () {
                            animateOnClose();
                            setSidebarTrigger(props.trigger ? props.trigger : ESidebarTrigger.CLICK);
                        } },
                    React.createElement("i", { className: "edel-icon-arrow-left1" }))) : (React.createElement(React.Fragment, null))),
            React.createElement("div", { className: "body-footer-container" },
                React.createElement("div", { className: "body-wrapper " }, props.navigationMenu.map(function (item, index) {
                    return item.subList && item.subList.length ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "d-flex align-items-center gap-3 hand_cursor DMSanM_14_500 link-with-subList justify-content-between ".concat(item.className ? item.className : "", " ").concat(item.subList
                                .map(function (val) {
                                return val.route;
                            })
                                .indexOf(location.pathname) > -1
                                ? "active-tab"
                                : ""), onClick: function () {
                                setIsShowSubList({
                                    isShow: !isShowSubList.isShow,
                                    eventKey: index.toString(),
                                });
                            } },
                            React.createElement("span", { className: "subList-heading-wrapper" }, item.icon ? (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "icon-container" }, item.icon),
                                React.createElement("span", { className: "title-container DMSanN_14_400" }, item.title))) : (React.createElement("span", { className: "title-container DMSanN_14_400" }, item.title))),
                            isShowSubList.isShow &&
                                isShowSubList.eventKey === index.toString() ? (React.createElement("i", { className: "edel-icon-round-circle-minus" },
                                React.createElement(Edelicon, { className: "edel-icon-round-circle-minus", paths: 2 }))) : (React.createElement("i", { className: "edel-icon-rounded-plus-2" },
                                React.createElement(Edelicon, { className: "edel-icon-rounded-plus-2", paths: 3 })))),
                        isShowSubList.isShow &&
                            isShowSubList.eventKey === index.toString() && (React.createElement("div", { className: "d-flex gap-3 flex-column DMSanM_14_500 subList-wrapper" },
                            React.createElement("div", { className: "line-for-sublist-items" }),
                            item.subList.map(function (subListItem) {
                                return (React.createElement(Link, { className: "open-sidebar-link-container DMSanM_14_500 hand_cursor  ".concat(item.className ? item.className : "", " ").concat(location.pathname === subListItem.route
                                        ? "active-tab"
                                        : ""), to: subListItem.route, state: subListItem === null || subListItem === void 0 ? void 0 : subListItem.routeState, key: index, onClick: function (e) {
                                        if ((subListItem === null || subListItem === void 0 ? void 0 : subListItem.callBackFunction) !== null &&
                                            (subListItem === null || subListItem === void 0 ? void 0 : subListItem.callBackFunction) !== undefined &&
                                            typeof (subListItem === null || subListItem === void 0 ? void 0 : subListItem.callBackFunction) ===
                                                "function") {
                                            subListItem === null || subListItem === void 0 ? void 0 : subListItem.callBackFunction();
                                        }
                                        // animateOnClose(); to be confirmed with BA First
                                        e.stopPropagation();
                                    } }, subListItem.icon ? (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon-container" }, subListItem.icon),
                                    React.createElement("span", { className: "title-container DMSanN_14_400" }, subListItem.title))) : (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "subList-dummy-icon" }),
                                    React.createElement("span", { className: "title-container DMSanN_14_400" }, subListItem.title)))));
                            }))))) : (React.createElement(Link, { className: "open-sidebar-link-container DMSanM_14_500 hand_cursor ".concat(item.className ? item.className : "", " ").concat(location.pathname === item.route ? "active-tab" : ""), to: item.route, state: item === null || item === void 0 ? void 0 : item.routeState, key: index, onClick: function () {
                            setIsShowSubList({ isShow: false, eventKey: "" });
                            (item === null || item === void 0 ? void 0 : item.onClick) && (item === null || item === void 0 ? void 0 : item.onClick(item));
                            // animateOnClose(); to be confirmed with BA First
                        }, target: item === null || item === void 0 ? void 0 : item.target }, item.icon ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "icon-container" }, item.icon),
                        React.createElement("span", { className: "title-container d-flex" },
                            item.title,
                            (item === null || item === void 0 ? void 0 : item.isShowComingSoon) && (React.createElement("span", { className: "DMsanR_08_400 txt-ochre ms-1 coming-soon-tag" }, "Coming soon"))))) : (React.createElement("span", { className: "title-container DMSanN_14_400" }, item.title))));
                })),
                React.createElement("div", { className: "footer-wrapper" }, props.footer ? props.footer : React.createElement(React.Fragment, null)))));
    };
    // React.useEffect(() => {
    //   console.log("collapsed state", props.isCollapsed);
    //   if (!props.isCollapsed && openedSidebarRef && openedSidebarRef.current) {
    //     let newClassName =
    //       openedSidebarRef.current.className + " closing-sidebar";
    //     openedSidebarRef.current.className = newClassName;
    //   }
    // }, [props.isCollapsed]);
    // React.useEffect(() => {
    //   setTemp(false);
    // }, []);
    React.useEffect(function () {
        var body = document.querySelector("body");
        body.style.overflow = props.isCollapsed ? "auto" : "hidden";
    }, [props.isCollapsed]);
    function clickOutside(e) {
        var _a;
        if (((_a = props.sideBarRef) === null || _a === void 0 ? void 0 : _a.current) &&
            !props.sideBarRef.current.contains(e.target)) {
            animateOnClose();
        }
    }
    React.useEffect(function () {
        document.addEventListener("mousedown", clickOutside);
        return function () {
            document.removeEventListener("mousedown", clickOutside);
        };
    }, [props.sideBarRef, isShowOpenedSidebarPermanently]);
    return (React.createElement(React.Fragment, null,
        generateCollapsedComponents(),
        !props.isCollapsed && generateOpenedComponents()));
};
export default GenericCollapsibleNavigation;
